import React from 'react';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import Button from 'commonComponents/Button/Button';
import LocationsPins from '../LocationsPins/LocationsPins';
import Carousel from 'commonComponents/Carousel/Carousel';
import styles from './Overview.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const Overview = ({ data: { header, subheader, text, info, button, districts }, map, context, link }) => {
  return ( 
    <section className={ styles.Overview }>
      <div className={ styles.content }>
        <PrimarySectionHeader
          header={ header }
          subheader={ subheader }
          anchor='overview'
        />
        <div className={ styles.info }>
          <figure>
            <img src={ map } />
          </figure>
          <article>
            <p className={ styles.text }>{ text }</p>
            <dl>
              { info && info.map(item => 
                <React.Fragment key={ item.title }>
                  <dt>{ item.title }:</dt>
                  <dd>{ item.text }</dd>
                </React.Fragment>
              ) }
            </dl>
            <Button label={ button } link={ link }
              additionalClass={ styles.button }
            />
          </article>
        </div>
        <div className={ styles.districts }>
          <LocationsPins list={ districts } />
        </div>
        <Carousel context={ context } />
      </div>
    </section>
  );
};
 
export default Overview;